'use client'
import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { auth, firestore } from '@/services/firebase.service'
import { collection, getDocs, query, where } from 'firebase/firestore'
import { validateSession } from '@/actions/authActions'
import { deleteCookie } from '@/actions/coockiesActions'
import { AuthSwitch } from '@/auth'
import './spinner.css'

//The UserAuthComponent component handles user authentication by checking cookies, displaying user data, logging in, and logging out the user.
export default function UserAuthComponent() {

  const router = useRouter();
  const isLocal = process.env.NODE_ENV === "development";

  const [openAuth, setOpenAuth] = useState({ open: false, step: 0 })
  const [user, setUser] = useState(null)

  const openAuthSwitch = step => setOpenAuth({ open: true, step })

  const deleteDni = async () => await deleteCookie('dni');

  const getToken = async (loggedUser, token) => {
    const { success } = await validateSession();
    if (!success) {
      if (isLocal)
        return router.push('/auth/login')

      return router.push('https://marinebroker.com.ar')
    }
    setUser({ ...loggedUser, token });
  }

  useEffect(() => {
    const unsuscribe = auth.onAuthStateChanged(authUser => {

      if (authUser) {
        // Create a query to get user data from Firestore
        let q = query(collection(firestore, 'users'), where('uid', '==', authUser?.uid));
        getDocs(q)
          .then(async result => {
            let loggedUser = (result.docs[0].data()); // Get user data
            let token = await authUser.getIdToken(true); // Get ID token
            await getToken(loggedUser, token);
          })
          .catch((err) => {
            if (isLocal)
              return router.push('/auth/login')

            return router.push('https://marinebroker.com.ar')
          })
      } else {
        if (isLocal)
          return router.push('/auth/login')

        return router.push('https://marinebroker.com.ar')
      }
      return () => unsuscribe();
    });
  }, [])

  return (
    <>
      {
        user ?
          <>
            <div className='w-full md:w-auto gap-x-2 flex justify-between md:justify-start items-center'>
              <Link onClick={deleteDni} href='/broker' className='border-b-2 border-primary text-primary flex justify-center items-center md:text-xs xl:text-base font-semibold hover:scale-110 transition-all duration-300'>
                Mis pólizas
              </Link>
              <button type='button' onClick={() => openAuthSwitch(2)} className='hover:scale-110 transition-all duration-300'>
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-user-circle" width="44" height="44" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#000000" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                  <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                  <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
                </svg>
              </button>
            </div>
            {openAuth && <AuthSwitch authVisible={openAuth} setAuthVisible={setOpenAuth} userData={user} />}
            {
              user?.role === 'admin' &&
              <Link href='/backOffice/users' className='hidden md:flex h-10 items-center justify-center px-4 text-sm 2xl:text-base font-semibold text-black border shadow-lg'>
                BackOffice
              </Link>
            }
          </>
          : <div className="spinner">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
          </div>
      }
    </>
  )
};